import { useLayoutEffect } from "react";
import ContainerSignInEmail from "./Components/ContainerSignInEmail";

export default function SignInEmail() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark">
      <ContainerSignInEmail text="ورود به حساب کاربری" />
      <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
    </div>
  );
}
